/* Suggestions du panier : ajout en un geste, choix d'une autre taille, et public (femme / homme) transmis au panier.
   Le rendu vient du serveur (section api-cart-items) : après un ajout, le thème recharge le panier et les suggestions. */
(() => {
  if (window.TECartSuggestions) return;
  window.TECartSuggestions = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Public mémorisé : la bascule Femme / Homme de la fiche, sinon la dernière collection femme ou homme visitée. */
  const path = location.pathname.toLowerCase();
  try {
    if (/\/collections\/femme(\/|$)/.test(path)) sessionStorage.setItem('te-shopping-audience', 'femme');
    if (/\/collections\/homme(\/|$)/.test(path)) sessionStorage.setItem('te-shopping-audience', 'homme');
  } catch (e) { /* stockage indisponible */ }
  const audience = () => {
    try {
      const g = sessionStorage.getItem('te-size-gender');
      if (g === 'F') return 'femme';
      if (g === 'H') return 'homme';
      return sessionStorage.getItem('te-shopping-audience') || '';
    } catch (e) { return ''; }
  };
  const syncAudience = async (block) => {
    const wanted = audience();
    if (!wanted || !block || block.dataset.tePublic === wanted) return false;
    try {
      const r = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { te_public: wanted } })
      });
      return r.ok;
    } catch (e) { return false; }
  };

  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-te-sugg-open]');
    if (open) {
      const item = open.closest('[data-te-sugg-item]');
      const sizes = item && item.querySelector('.te-cart-sugg__sizes');
      if (!sizes) return;
      const show = sizes.hidden;
      sizes.hidden = !show;
      item.querySelectorAll('[data-te-sugg-open]').forEach((b) => b.setAttribute('aria-expanded', String(show)));
      if (show) { const first = sizes.querySelector('button:not([disabled])'); if (first) first.focus(); }
      return;
    }
    const add = event.target.closest('[data-te-sugg-add]');
    if (!add || add.disabled) return;
    const item = add.closest('[data-te-sugg-item]');
    const error = item && item.querySelector('[data-te-sugg-error]');
    add.disabled = true;
    add.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.teSuggAdd), quantity: 1 }] })
      });
      if (!r.ok) {
        let msg = 'Ajout impossible pour le moment.';
        try { const j = await r.json(); msg = j.description || msg; } catch (e) { /* réponse vide */ }
        throw new Error(msg);
      }
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    } catch (reason) {
      add.disabled = false;
      add.removeAttribute('aria-busy');
      if (error) { error.textContent = reason.message; error.hidden = false; }
    }
  });

  /* Coloris du bonnet offert choisi dans le bloc cadeau : transmis au panier pour proposer l'écharpe assortie.
     Écoute en capture : le bloc est encore en place pour savoir où était le focus. */
  let giftSent = null;
  /* Le bloc cadeau se redessine après le rechargement du panier : on rend le focus clavier au même choix. */
  const keepFocus = (picker, selector) => {
    const restore = () => {
      const a = document.activeElement;
      if (a && a !== document.body && a.isConnected) return;
      const el = picker.querySelector(selector);
      if (el) el.focus({ preventScroll: true });
    };
    const mo = new MutationObserver(restore);
    mo.observe(picker, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 6000);
  };
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('te-gift-picker');
    if (!picker || !event.target.closest('[data-rule="manches"]')) return;
    const selector = event.target.hasAttribute('data-skip')
      ? '[data-rule="manches"] [data-skip]'
      : '[data-rule="manches"] input[value="' + event.target.value + '"]';
    const hadFocus = picker.contains(document.activeElement);
    /* Lu après le rendu du bloc : en décochant « sans ce cadeau », le coloris mémorisé réapparaît. */
    setTimeout(() => {
      const section = picker.querySelector('[data-rule="manches"]');
      const picked = section && !section.querySelector('[data-skip]:checked') && section.querySelector('.te-gift-choice input:checked');
      const colour = picked ? picked.closest('.te-gift-choice').textContent.trim().toLowerCase().split(/\s+/).pop() : '';
      if (colour === giftSent) return;
      giftSent = colour;
      if (hadFocus) keepFocus(picker, selector);
      sendGiftColour(colour);
    }, 0);
  }, true);
  const sendGiftColour = (colour) => {
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { te_gift_colour: colour } })
    }).then((r) => {
      if (r.ok) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    }).catch(() => { /* les suggestions standard restent affichées */ });
  };

  /* Quand le bloc apparaît (ouverture ou mise à jour du panier), on transmet le public s'il a changé, puis on recalcule une fois. */
  if (!audience()) return;
  let synced = false;
  let observer = null;
  const check = async () => {
    if (synced) return;
    const block = document.querySelector('[data-te-cart-sugg]');
    if (!block) return;
    synced = true;
    if (observer) observer.disconnect();
    if (await syncAudience(block)) document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  };
  if ('MutationObserver' in window) {
    observer = new MutationObserver(() => { if (document.querySelector('[data-te-cart-sugg]')) check(); });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  check();
})();
